
export default defineNuxtRouteMiddleware((to, from) => {
   
   const { authed } = useAuthStore();
   if (to.name === "profile" && authed) {
      return navigateTo({ name: "profile-classes" });
   }
});
